import {SecureService} from "@/services/superclasses/secure-service";
import {FormResponse} from "@/interfaces/form-response";
import {WatchListSubscription} from "@/interfaces/watch-list-subscription";

const api = window.contextPath + '/rest/watch-lists';

export class WatchListSubscriptionSecureService extends SecureService {

    public update = async (watchListId: number, data: WatchListSubscription): Promise<FormResponse<void>> => {
        return this.data(await this.put<FormResponse<void>>(api + "/" + watchListId + "/subscriptions", data));
    }

    public getByWatchListId = async (watchListId: number): Promise<WatchListSubscription> => {
        return this.data(await this.get<WatchListSubscription>(api + "/" + watchListId + "/subscriptions"));
    }
}

export const watchListSubscriptionSecureService = new WatchListSubscriptionSecureService()